import React, { useState } from "react";
interface IAllMandate {
  mandateID: string;
  createdOn: string;
  amount: string;
  bank: string;
  Status: string;
  setviewMandate: Function;
  showView: boolean;
  setviewMandatecalender?: Function;
  isEvenRow: boolean;
  isTableHead: boolean;
}

const AllMandate = (props: IAllMandate) => {
  const dynamicClass =
    props?.Status === "Not Approved" ? "txt_bloodRed" : "txt_green";
  return (
    <>
      <div
        className={`all-mandate-section ${
          props?.isEvenRow
            ? "mandatesection-even-row"
            : "mandatesection-odd-row"
        }`}
      >
        <div className={props.isTableHead ? "mandate-data-table" : ""}>
          {!props.isTableHead ? (
            <>
              <span className="mandate-head">Mandate ID</span>
              <span className="mandate-data ">{props.mandateID}</span>
            </>
          ) : (
            <span className="mandate-data mandate-data-table">
              {props.mandateID}
            </span>
          )}
        </div>
        <div className={props.isTableHead ? "mandate-data-table" : ""}>
          {!props.isTableHead ? (
            <>
              <span className="mandate-head">Created on</span>
              <span className="mandate-data">{props.createdOn}</span>
            </>
          ) : (
            <span className="mandate-data mandate-data-table">
              {props.createdOn}
            </span>
          )}
        </div>
        <div className={props.isTableHead ? "mandate-data-table" : ""}>
          {!props.isTableHead ? (
            <>
              <span className="mandate-head">Amount</span>
              <span className="mandate-data">{props.amount}</span>
            </>
          ) : (
            <span className="mandate-data mandate-data-table">
              {props.amount}
            </span>
          )}
        </div>
        <div className={props.isTableHead ? "mandate-data-table" : ""}>
          {!props.isTableHead ? (
            <>
              <span className="mandate-head">Bank</span>
              <span className="mandate-data">{props.bank}</span>
            </>
          ) : (
            <span className="mandate-data mandate-data-table">
              {props.bank}
            </span>
          )}
        </div>
        <div className={props.isTableHead ? "mandate-data-table" : ""}>
          {!props.isTableHead ? (
            <>
              <span className="mandate-head">Status</span>
              <span
                className={`mandate-data ${dynamicClass}`}
                data-attr={props.Status}
              >
                {props?.Status === "Approved" ? "Approved" : "Not Approved"}
              </span>
            </>
          ) : (
            <span
              className={`mandate-data ${dynamicClass}`}
              data-attr={props.Status}
            >
              {props?.Status === "Approved" ? "Approved" : "Not Approved"}
            </span>
          )}
        </div>

        {props.showView ? (
          <>
            <div className="d-flex justify-content-center align-items-center">
              <span
                className="mandate-data manadate-data-icon hand_cursor"
                onClick={() => {
                  props?.setviewMandate({
                    mandateId: props?.mandateID,
                    date: props?.createdOn,
                  });
                  props?.setviewMandatecalender(true);
                }}
              >
                View <i className="edel-icon-arrow-right"></i>
              </span>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default AllMandate;
